






























































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Commande} from '@/models';

import storeCommande from '@/stores/modules/commande';
import storeClient from '@/stores/modules/client';

import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
import CrudClientSearch from "@/components/Crud/Client/Search.vue";
import CrudBoisTypeSearch from "@/components/Crud/BoisType/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputDatePicker from "@/components/Input/DatePicker.vue";
import storeVente from "@/stores/modules/vente";
import storeBoisType from "@/stores/modules/boisType";
import storeLongueursVente from "@/stores/modules/longueursVente";
import storePile from "@/stores/modules/pile";
import storeTransporteur from '@/stores/modules/transporteur';

@Component({
	components: {
		CrudTransporteurSearch,
		CrudClientSearch,
		CrudBoisTypeSearch,
		InputBoisType,
		InputDatePicker,
	}
})
export default class CrudCommandeEdit extends AbstractEditVue<Commande> {

	// DF: utiliser pour la création d'un commande uniquement
	// en modification on passe par la light
	private step: number = 1;
	private savedisabled: Boolean = true;
	private checkDivers: Boolean = false;

	private storeClient = storeClient
	private storeBoisType = storeBoisType
	private storeLongueursVente = storeLongueursVente

	public constructor() {
		super(
			storeCommande,
			'Commande modifié',
			'Commande créé',
		);
	}

	//	@Emit()
	//	private onNext() {
	//		if ((!this.item.address) || (this.item.address === null) )
	//		{
	//			this.item.address = this.item.name;
	//		}
	//		this.step = 2;
	//	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}


	public watcher() {
		if (this.item) {
			if (this.item.client && this.item.boisType && this.item.longueursVente) {
				this.savedisabled = false;
			} else {
				this.savedisabled = true;
			}
		}
	}

	public async mounted(): Promise<void> {
		super.mounted();
		await storeClient.dispatch('getAll');
		await storeBoisType.dispatch('getAll');
		await storeLongueursVente.dispatch('getAll');
		this.watcher();
	}

}
